<template>
  <div class="auto-number">
    <el-checkbox v-model="content.checked" @change="handlerCheckbox"></el-checkbox>
    <div class="serial-label">
      <span class="text-medium leading-22 ml-8 mr-3 text-theme-black-650">自增序号</span>
    </div>
    <el-select v-model="value" size="small" class="bg-white-input mr-3" style="width:312px">
      <el-option v-for="o in options" :key="o.value" :value="o.value" :label="o.label" />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'AutoNumber',
  props: {
    content: Object
  },
  data() {
    return {
      value: '',
      options: []
    }
  },
  methods: {
    getValue() {
      return this.value
    },
    setValue(val) {
      this.value = val
    },
    initOptions() {
      let n = 8
      let options = []
      while (n > 0) {
        options.unshift({
          label: n,
          value: n + ''
        })
        n--
      }
      this.options = options
    },
    handlerCheckbox(val) {
      if(!this.value) {
        return
      }
      if(val) {
        let n = Number(this.value)
        let str = '0'.repeat(n - 1)
        str += '1'
        this.$emit('format-change', str)
      } else {
        this.$emit('format-change', '')
      }
    }
  },
  created() {
    this.initOptions()
    if (this.content.defaultValue) {
      this.setValue(this.content.defaultValue)
    }
  },
  watch: {
    value(v) {
      let n = Number(v)
      let str = '0'.repeat(n - 1)
      str += '1'
      if(this.content.checked) {
        this.$emit('format-change', str)
      } else {
        this.$emit('format-change', '')
      }
      this.$emit('set-defaultValue', this.content.name, v)
    }
  }
}
</script>

<style scoped></style>
